export var CameraMode;
(function (CameraMode) {
    CameraMode[CameraMode["SHOWCASE"] = 0] = "SHOWCASE";
    CameraMode[CameraMode["FOLLOW_PLAYER"] = 1] = "FOLLOW_PLAYER";
    CameraMode[CameraMode["ALL_MAP"] = 2] = "ALL_MAP";
})(CameraMode || (CameraMode = {}));
